import {
  Accordion,
  AccordionItem,
  AccordionButton,
  AccordionPanel,
  Box,
  Center,
  Heading,
} from '@chakra-ui/react';

import { MdAdd } from 'react-icons/md';

import { sansFonts } from '@inspire/ui/static';

import NoWrap from 'components/landing-pages/NoWrap';

const QA = ({ QAContent }) => (
  <>
    <Center>
      <Heading as="h3" mt={0} fontFamily={sansFonts}>
        Des <NoWrap>questions ?</NoWrap>{' '}
      </Heading>
    </Center>
    <Center>
      <Accordion w="100%" maxW="600px" allowMultiple allowToggle>
        {QAContent.map((qa) => (
          <AccordionItem key={qa.id}>
            <AccordionButton flex="1" justifyContent="space-between">
              <Box fontSize="lg" textAlign="left">
                {qa.question}
              </Box>
              <MdAdd />
            </AccordionButton>

            <AccordionPanel>{qa.answer}</AccordionPanel>
          </AccordionItem>
        ))}
      </Accordion>
    </Center>
  </>
);

export default QA;
